import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import React from 'react';
import Button from '../../../shared/components/atoms/button/button';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import useMobile from '../../../shared/hooks/useMobile';
import { localStorage } from '../../../shared/utils/storage';
import useInfoTransversal from "../../../shared/hooks/useInfoTransversal"
import ModalKeys from '../../../shared/components/molecules/modal-keys/modal-keys'
import './section-club-invitation.scss';


const SectionClubInvitation = ({ clubData, setActiveModal }) => {

    const { homeLink } = useHomeLinkMode();
    const mobile = useMobile();
    const { countryInfoTransversal } = useInfoTransversal();

    return (
      <section className="f-m-club-invitation">
        <div className="f-m-club-invitation__content">
          {clubData[0].imagenInvitacionClubHome && (
            <div className="f-m-club-invitation__phone-container">
              <GatsbyImage
                image={
                  clubData[0].imagenInvitacionClubHome[mobile ? 1 : 0]
                    .gatsbyImageData
                }
                alt="phone image"
                className="f-m-club-invitation__phone"
              />
            </div>
          )}
          <div className="f-m-club-invitation__info-box">
            <div className="f-m-club-invitation__info">
              <img
                className="f-m-club-invitation__logo"
                src={countryInfoTransversal[0].logoClubPequenin.file.url}
                alt={countryInfoTransversal[0].logoClubPequenin.description}
                placeholder="blurred"
                loading="lazy"
              />
              {clubData[0].fraseInvitacionClubHome && (
                <GatsbyImage
                  image={clubData[0].fraseInvitacionClubHome.gatsbyImageData}
                  alt={clubData[0].fraseInvitacionClubHome.description}
                  className="f-m-club-invitation__phrase"
                />
              )}
              <Button
                className={
                  "f-a-button__primary-blue " +
                  (mobile ? "f-a-button__small" : "f-a-button__medium")
                }
                id="f-a-button__club-invitation"
                copy={
                  localStorage.getItem("TOKEN_INFO")
                    ? "Ingresa tus claves"
                    : "Únete ahora"
                }
                onclick={() => {
                  if (localStorage.getItem("TOKEN_INFO")) {
                    setActiveModal(
                      <ModalKeys closeModal={() => setActiveModal(false)} />
                    )
                  } else {
                    sessionStorage.setItem(
                      "PREVIOUS_PAGE",
                      window.location.href
                    )
                    location.href =
                      homeLink +
                      (process.env.ENVIRONMENT === "LOCAL" ? "" : "registro")
                  }
                }}
              />
            </div>
          </div>
        </div>
      </section>
    )
}

export default SectionClubInvitation
